/**
 * Please note react-unstuck sticky items highest z-index is 1000
 */
const zIndexUtil = {
  skipLink: -1001,
  skipLinkActive: 1001,
  tooltip: 1015,
  popover: 111,
  dimmer: 1011,
  modal: 1013,
  drawer: 1013,
  dock: 1001,
  stickyInModelDefaultZIndex: 1014,
  fullscreenLayout: 1012,
  floatingActionButton: 99,
  floatingActionButtonMenu: 100,
  inPageSearchControlsDesktop: 1,
  inPageSearchControlsMobile: 1012,
  searchBarFixed: 1012,
  stickyDefaultZIndex: 2,
  tableCommandBarActions: 1013,
  autocompleteSearch: 1013,
  toggle: 99
};

export { zIndexUtil };
//# sourceMappingURL=zIndexUtil.js.map
